<!-- 中间页-免登陆 -->
<template>
  <div class="home">
    <a-spin v-if="loading" class="home-loading" size="large" />
    <div v-if="isShow" class="home-warp">
      <div class="home-warp-box">
        <!-- <img src="./images/title.png" /> -->
        <!-- <div class="warp-box-concent">
          <div class="concent-title">账号停用提示</div>
          <div>
            您的账号已经超过<span style="color: #ff0000">3个月</span
            >未使用，由于安全原因已自动停用
          </div>
          <div class="concent-tip">如需使用请联系各省管理人员进行账号启用</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import API from "@/api/login";

export default {
  data() {
    return {
      loading: false,
      isShow: false
    };
  },
  created() {
    localStorage.removeItem("token");
    let url = window.location.href.split("?");
    let data = url ? url[1] : "";
    if (data && data.indexOf("code") != -1) {
      this.getUser();
    }
  },
  methods: {
    getUser() {
      this.loading = true;
      API.thirdLogin(
        {
          code: this.$route.query.code || "",
        },
        (callback) => {
          this.loading = false;
          this.isShow = false;
          if (callback.status == "S" && callback.data) {
            const userInfo = callback.data;
            if (userInfo.token) {
              localStorage.setItem("token", userInfo.token);
            }
            this.setUserInfo(callback.data.user);
            if (Array.isArray(userInfo.menus) && userInfo.menus.length > 0) {
              let menus = [];
              menus = userInfo.menus;
              this.setMenus(menus);
              this.$router.push(menus[0].path);
            }
          } else if (callback.status == "F" && callback.code == "52") {
            this.isShow = true;
          }
        }
      );
    },
    ...mapMutations(["setUserInfo", "setMenus"]),
  },
};
</script>

<style scoped lang="less">
.home {
  margin: 0 auto;
  text-align: center;
  width: 100%;
  height: 100%;

  .home-loading {
    padding-top: 10%;
  }

  .home-warp {
    height: 100%;
    background-image: url("./images/bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .home-warp-box {
      position: relative;
      img {
        width: 220px;
        height: 140px;
        position: absolute;
        top: -50px;
        left: 50%;
        margin-left: -110px;
      }
      .warp-box-concent {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #333333;
        padding: 100px 130px 50px;
        background: linear-gradient(
          180deg,
          #fff0f0,
          #fff0f0 17%,
          #ffffff 48%,
          #ffffff
        );
        box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.06);
        .concent-title {
          font-size: 24px;
          padding-top: 24px;
          padding-bottom: 10px;
        }
        .concent-tip {
          color: #999999;
          padding-top: 2px;
        }
      }
    }
  }
}
</style>
